import React from "react";
import { withRouter } from "react-router";

class Logout extends React.Component {
  componentDidMount() {
    localStorage.clear();
  }

  render() {
    this.props.history.push("/login");
    return <div>logout</div>;
  }
}

export default withRouter(Logout);
